import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "../config/config.service";
import {Funcao} from "../types/Funcao";
import {Acao} from "../types/Acao.type";

@Injectable({
  providedIn: 'root'
})
export class AcaoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAcoes(id: String){
    return this.httpClient.get<Acao[]>(`${this.configService.getApiUrl()}/acoes/modulo/${id}`);
  }
}
